import { ScenarioComponent } from '../types/components';
import { atom, selectorFamily } from 'recoil';
import { jsonValue } from '../types/jsonValue';
import { Color } from '../types/colors';

export interface SkipCondition {
  condition: {[componentId: string]: jsonValue};
  skipScenarioItemIds: string[];
}

export interface ScenarioItem {
  id: string;
  type: 'opposite' | 'self'
  components: ScenarioComponent[];
  skip: SkipCondition[];
}

export interface Scenario {
  header: {
    title: string;
  };
  balloon: {
    icon: string;
  };
  body: {
    color: Color;
  };
  items: ScenarioItem[];
}


export const scenarioState = atom<Scenario>({
  key: 'scenario'
});

export const completedComponentIdsState = atom<string[]>({
  key: 'completedItemIds',
  default: [],
});

export const recentlyItemCompleted = atom<boolean>({
  key: 'lastItemCompletedTime',
  default: false,
  effects: [({onSet, setSelf}) => {
    onSet((value) => {
      if (!value) return;
      const id = requestAnimationFrame(() => setSelf(false));
      return () => cancelAnimationFrame(id);
    });
  }]
});

export const scenarioItemState = selectorFamily<ScenarioItem, string>({
  key: 'scenarioItem',
  get: (itemId) => {
    return ({get}) => get(scenarioState).items.find(i => i.id === itemId)!;
  }
});

export const compositedScenarioItemState = selectorFamily<ScenarioItem, string>({
  key: 'compositedScenarioItem',
  get: (componentId) => ({get}) => {
    const scenario = get(scenarioState);
    return scenario.items.find(i => i.components.map(c => c.id).includes(componentId))!;
  }
})

